export default {
    FRAU: {
        value: 2,
        text: 'Frau'
    },
    HERR: {
        value: 1,
        text: 'Herr'
    }
}